<script>
    import { styles } from './styles.js'
    export let bgColor;
    export let bgColor2;
    export let hoverBgColor;

    export let scene;
    export let text;
    export let x;
    export let y;

    function loadScene(){
        window.CC.krpano.call(`loadscene(${scene});`)
    }
</script>

<style>
    div {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
        width: 150px;
        text-align: center;
        font-size: 20px;
        font-family: Oswald, "Helvetica Neue", Helvetica, Arial, sans-serif; 
        letter-spacing: 0px;
        font-weight: 700;
        border-radius: 3px;
        padding: 8px 12px;
        color: #fff0ce;
        color: #fff;
        
        background: var(--scene-button-bg-color);
        background: -webkit-radial-gradient(center, var(--scene-button-bg-color), var(--scene-button-bg-color-2));
        background: -moz-radial-gradient(center, var(--scene-button-bg-color), var(--scene-button-bg-color-2));
        background: radial-gradient(ellipse at center, var(--scene-button-bg-color), var(--scene-button-bg-color-2));

        text-transform: uppercase;
        text-shadow: rgba(0, 0, 0, 0.6) 2px 1px 2px;
        box-shadow: rgba(255, 255, 255, 0.25) 2px 1px 6px;
    }

    div:hover {
        cursor: pointer;
        background: var(--scene-button-hover-bg-color);
        text-transform: uppercase;
        text-shadow: rgba(0, 0, 0, 0.6) 2px 1px 2px;
        box-shadow: rgba(0, 0, 0, 0.25) 2px 1px 2px;
    }
</style>

<div use:styles={{ 
        'scene-button-bg-color': bgColor, 
        'scene-button-bg-color-2': bgColor2, 
        'scene-button-hover-bg-color': hoverBgColor 
    }} 
    
    style={`top: ${y}px; left: ${x}px;`}

    on:click="{loadScene}"     
>
    {text}
</div>